// Definição para o modal de busca de Clientes (Parceiros com IsCliente == true)
export const criarConfigBuscaCliente = (idOrganizacao) => ({
  label: 'Cliente',
  placeholder: 'Nome ou Documento...',
  titulo: 'Pesquisar Cliente',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  displayField: 'idParceiro',
  descField: 'nomeFantasia',
  camposFiltro: [
    { label: 'Nome ou Documento', model: 'busca', tipo: 'text' },
    { label: 'Organização', model: 'idOrganizacao', tipo: 'hidden', value: idOrganizacao }
  ],
  colunasGrid: [
    { header: 'Nome', dataField: 'nomeFantasia', width: '60%' },
    { header: 'Documento', dataField: 'documento', width: '40%' }
  ],
  filtrosFixos: { idOrganizacao, isCliente: true }
})
